__turbopack_context__.v({
  "arrow": "_8NXLSa_arrow",
  "cta": "_8NXLSa_cta",
  "ctaWrap": "_8NXLSa_ctaWrap",
  "device": "_8NXLSa_device",
  "fine": "_8NXLSa_fine",
  "head": "_8NXLSa_head",
  "headline": "_8NXLSa_headline",
  "inner": "_8NXLSa_inner",
  "keyDevice": "_8NXLSa_keyDevice",
  "keyMember": "_8NXLSa_keyMember",
  "label": "_8NXLSa_label",
  "legend": "_8NXLSa_legend",
  "member": "_8NXLSa_member",
  "note": "_8NXLSa_note",
  "pro": "_8NXLSa_pro",
  "row": "_8NXLSa_row",
  "rowHead": "_8NXLSa_rowHead",
  "rows": "_8NXLSa_rows",
  "section": "_8NXLSa_section",
  "seg1": "_8NXLSa_seg1",
  "sub": "_8NXLSa_sub",
  "title": "_8NXLSa_title",
  "total": "_8NXLSa_total",
  "totalPro": "_8NXLSa_totalPro",
  "track": "_8NXLSa_track",
  "yearPill": "_8NXLSa_yearPill",
  "years": "_8NXLSa_years",
});
